
/**
 * @file FormRegister
 */
'use strict';
import Common from '../../../Utils/Common';

/**
 * @classname FormRegister
 * @classdesc 
 */
export default class FormRegister {
	/**
	 * @constructor
	 * @param {object} controller - コントローラー
	 */
	constructor(controller){
		this._controller = controller;
	};


	/**
	 * フォーム送信前処理
	 *
	 * @memberof FormRegister
	 * @return {undefined}
	 */
	postProcessing($form) {
		console.log(`${this.constructor.name}.postProcessing`);

		const birthYear = $('#birth_year').val();
		const birthMonth = $('#birth_month').val();
		const birthDay = $('#birth_day').val();
		$('#birthday').val(`${birthYear}/${birthMonth}/${birthDay}`)

		this._controller.completePostProcessing($form);
	};
}
